/**
 * ScreenCheck Portal API
 * ScreenCheck Portal REST API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The MySensorsResponse model module.
 * @module model/MySensorsResponse
 * @version 0.0.1
 */
class MySensorsResponse {
    /**
     * Constructs a new <code>MySensorsResponse</code>.
     * @alias module:model/MySensorsResponse
     */
    constructor() { 
        
        MySensorsResponse.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>MySensorsResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/MySensorsResponse} obj Optional instance to populate.
     * @return {module:model/MySensorsResponse} The populated <code>MySensorsResponse</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new MySensorsResponse();

            if (data.hasOwnProperty('devices')) {
                obj['devices'] = ApiClient.convertToType(data['devices'], [Object]);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>MySensorsResponse</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>MySensorsResponse</code>.
     */
    static validateJSON(data) {
        // ensure the json data is an array
        if (!Array.isArray(data['devices'])) {
            throw new Error("Expected the field `devices` to be an array in the JSON data but got " + data['devices']);
        }

        return true;
    }


}



/**
 * @member {Array.<Object>} devices
 */
MySensorsResponse.prototype['devices'] = undefined;






export default MySensorsResponse;

